
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo" [completelyHidden]="false"></workflow-no-access>
<div class="container" [ngClass]="{'general-disabled': orderForm?.isMigrationActive}">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p [hidden]="!waitingForRequest">The Transition Lead has not confirmed this order form.</p>
        <p [hidden]="!canPlaceOrder">
          This order form was confirmed by the Transition Lead. Click "Continue" once the order has been placed.</p>
        <p [hidden]="!orderPlaced">The Account Lead has placed this order.</p>
      </div>
      <div class="float-right">
        <button class="btn btn-outline-danger" type="button" (click)="rejectOrder()" [hidden]="!orderCanBeRejected"><span class="oi oi-warning"></span> Reject Order</button>
      </div>
    </div>
  </div>
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <order-form [hidden]="waitingForRequest" [allowEditing]="editableFields" [orderForm]="orderForm" (error)="error = $event['error']"></order-form>
</div>